import React, { Box } from '@mui/material';
import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'hooks';
import { CoreRoutes } from 'app-constants';

type AnonymousRouteProps = {
    children: ReactNode;
}
const AnonymousRoute = ({ children }: AnonymousRouteProps) => {
    const { isAuth } = useAuth();
    return isAuth ? <Navigate to={CoreRoutes.home} replace /> : <>{children}</>;
};

export const AccountPageLayout = () => {
    return (
        <AnonymousRoute>
            <Box display='flex' justifyContent='center' alignItems='center' minHeight='100vh' >
                <Outlet />
            </Box >
        </AnonymousRoute>
    );
};
